export default "__VITE_ASSET__36e977a5__"